import type { HistoryTab } from '../../pages/TradingHistory';

interface HistoryTabsProps {
  tab: HistoryTab;
  onTabChange: (tab: HistoryTab) => void;
}

export default function HistoryTabs({ tab, onTabChange }: HistoryTabsProps) {
  return (
    <div className="history-tabs">
      <button className={tab === 'execution' ? 'active' : ''} onClick={() => onTabChange('execution')}>
        전략 실행 로그
      </button>
      <button className={tab === 'realized' ? 'active' : ''} onClick={() => onTabChange('realized')}>
        실현 손익
      </button>
    </div>
  );
}
